export const CHECK_USER_LOCATION = 'CHECK_USER_LOCATION';
export const CHECK_DARWIN_ATTENDANCE = 'CHECK_DARWIN_ATTENDANCE';
export const SUBMIT_DARWIN_ATTENDANCE = 'SUBMIT_DARWIN_ATTENDANCE';
